import { reportsApi } from '../reports.api';
import { PeriodDto, TopManagerDto, TopManagerLeaderDto } from '@sr/dto';

export type TopManagerQuery = {
  year: number,
  month: number
};

const injectedApi = reportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getTopManagerPeriods: builder.query<PeriodDto[], void>({
      query: () => ({
        url: 'top-manager/periods',
        method: 'GET'
      })
    }),
    getTopManager: builder.query<TopManagerDto[], TopManagerQuery>({
      query: ({ year, month }) => ({
        url: 'top-manager',
        params: { year, ...(month === -1 ? {} : { month }) }
      })
    }),
    getTopManagerLeaders: builder.query<TopManagerLeaderDto[], void>({
      query: () => 'top-manager/leaders'
    })
  })
});

export const topManagerApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['top-manager'],
  endpoints: {}
});
